<ng-container *ngIf="!authService.authenticating">
  <div class="row justify-content-center">
    <div class="col-auto">
      <fa-icon [icon]="faLockAlt" [fixedWidth]="true" size="6x"></fa-icon>
    </div>
  </div>
  <div *ngIf="!authService.error" class="row justify-content-center text-center pb-3">
    <div class="col">
      <h1 class="fw-black">Unauthorized</h1>
      <h5 class="fw-normal">It appears you don't have access to our user portal.</h5>
    </div>
  </div>
  <div *ngIf="authService.error" class="row text-center pb-3">
    <div class="col">
      <h1 class="fw-black">Something went wrong</h1>
      <h5 class="fw-normal">Don't worry, it's not you, it's us. We let our support team know of your issue.
      </h5>
      <h5 class="fw-normal">Sorry for the inconvenience, feel free to try loading the page again.</h5>
    </div>
  </div>
</ng-container>
